<template>
  <ListPane :getListMethod="getListMethod" :locked-filters="lockedFilters" :optional-filters="optionalFilters"
    :paginationEnabled="paginationEnabled" :itemsPerPage="itemsPerPage" :show-filter-tab="showFilterTab"
    :show-sorting-tab="showSortingTab" :show-search="showSearch" :groupBy="groupBy" :groupSort="groupSort"
    :groupItemSort="groupItemSort" :show-clear-filter="showClearFilter" :exportFunction="exportFunction"
    :set-preview-function="handleItemClick" :openFunction="handleItemClick" :dialog-trigger="dialogTrigger"
    :dialogItem="dialogItem" :dialog-method-config="dialogMethodConfig" :pk="pk"
    :scrollcheckTrigger="scrollcheckTrigger" :hideFooter="!multiple || !selectionFilter.checkedCount" ref="listpane"
    @Added="item => $emit('Added', item)">

    <template v-slot:header>
      <slot name="list-header">
      </slot>
    </template>

    <template v-slot:prepend-item="{ list, listloading }" v-if="allowSelectAll">
      <v-row v-if="!listloading && list && list.length > 1" no-gutters align="center" @click="toggleSelectAll()"
        style="cursor: pointer; background-color: #00000005; border-bottom: 1px solid #e8e7e7;">
        <v-col v-if="multiple" cols="auto" class="hovercol d-flex align-center justify-center px-3"
          style="height: 36px;">
          <div>
            <v-checkbox :value="selectionFilter.SelectAll" hide-details class="ma-0 pa-0 justify-center" :ripple="false"
              style="max-width: 32px !important;"
              :indeterminate="!!(selectionFilter.SelectAll && selectionFilter.uncheckedCount)"
              @click.stop="toggleSelectAll()">
            </v-checkbox>
          </div>
        </v-col>
        <v-col :cols="multiple ? 10 : 11" class="pl-3">
          {{ $t('servicesystem.common_objects.commonterms.all_items') }}
        </v-col>
        <v-col cols="1" class=" d-flex align-center justify-center" style="" @click.stop="">
        </v-col>
      </v-row>
    </template>

    <template v-slot:group-header="{ group, items }">
      <slot name="group-header" :group="group" :items="items" :selectionFilter="selectionFilter"
        :setSelectionFilter="setSelectionFilter" />
    </template>

    <template v-slot:list-item="{ index, item, groupIndex, handleadded, handlechanged, handleremoved }">
      <!-- extra wrapper arround the list item to show columns for multiple chackbox and preview button per item -->
      <slot name="list-item-wrapper" :index="index" :item="item" :groupIndex="groupIndex" :handleadded="handleadded"
        :handlechanged="handlechanged" :handleremoved="handleremoved" :previewable="previewable"
        :isPreviewed="previewIndex === `${groupIndex}-${index}`" :showDelete="itemDeleteFunc !== undefined"
        :deleteFunc="() => itemDeleteFunc(item)" :showCheckbox="multiple && !hideCheckboxesOnItems"
        :isChecked="isChecked(item)" :toggleCheckbox="() => toggleitem(item)"
        :openPreview="() => handlePreview(item, `${groupIndex}-${index}`)"
        :closePreview="() => handlePreview(null, null)" :selectionFilter="selectionFilter"
        :setSelectionFilter="setSelectionFilter" :handleItemClick="() => handleItemClick(item)"
        :handleMiddleClick="() => handleMiddleClick(item)">

        <SelectableListItemWrapper :previewable="previewable" :isPreviewed="previewIndex === `${groupIndex}-${index}`"
          :showDelete="itemDeleteFunc !== undefined"
          :deleteFunc="() => handleItemDelete(item, itemDeleteFunc, handleremoved)"
          :showCheckbox="multiple && !hideCheckboxesOnItems" :isChecked="isChecked(item)"
          :toggleCheckbox="() => toggleitem(item)" :openPreview="() => handlePreview(item, `${groupIndex}-${index}`)"
          :closePreview="() => handlePreview(null, null)" @PrimaryClick="handleItemClick(item)"
          @MiddleClick="handleMiddleClick(item)">

          <template v-slot:list-item>
            <!-- actual list item template used from higher level components -->
            <slot name="list-item" :index="index" :item="item" :groupIndex="groupIndex" :handleadded="handleadded"
              :handlechanged="handlechanged">
            </slot>
          </template>

        </SelectableListItemWrapper>

      </slot>
    </template>

    <template v-slot:empty-list-actions>
      <slot name="empty-list-actions">
        <v-btn v-if="createNewFunction" dark color="success" class="mb-3 " @click="createNewFunction()">
          <v-icon class="mr-3">mdi-plus</v-icon>
          {{ $t('servicesystem.common_objects.commonterms.create_new') }}
        </v-btn>
      </slot>
    </template>

    <template v-slot:footer>
      <MultiselectActionBar :selectionFilter="selectionFilter" :filter="mixedFilters" :selectText="selectText"
        :alternateSelectActions="alternateSelectActions" :selectMethod="() => select()" @clear="clearAllSelection()">
        <template v-slot:select-actions>
          <slot name="select-actions" :filter="mixedFilters" :selectionFilter="selectionFilter"
            :selectMethod="() => select()" :refreshListMethod="refreshList" :clearSelectionMethod="clearAllSelection">
          </slot>
        </template>
      </MultiselectActionBar>
    </template>


    <template v-slot:dialog-content="{ trigger, item, handlevalid }">
      <slot name="dialog-content" :item="item" :trigger="trigger" :handlevalid="handlevalid" />
    </template>

  </ListPane>
</template>


<script>
import ListPane from "@/components/Sections/Panes/ListPane.vue";
import FilterQueryMixin from "@/helpers/Mixins/FilterQueryMixin.js";
import SelectableListItemWrapper from "@/components/ListItems/SelectableListItemWrapper.vue";
import Vue from "vue";
import MultiselectActionBar from "./MultiselectActionBar.vue";

export default {
  name: "SelectableListPane",
  props: {
    pk: {
      type: String,
      default: "pipa"
    },
    title: {
      type: String,
      default: "SelectableListPane"
    },
    showFilterTab: Boolean,
    showSortingTab: Boolean,
    showSearch: {
      type: Boolean,
      default: true
    },
    showClearFilter: {
      type: Boolean,
      default: true
    },
    loading: Boolean,
    getListMethod: {
      type: Function,
      required: true
    },
    paginationEnabled: Boolean,
    itemsPerPage: Number,
    externalLoading: Boolean,
    multiple: Boolean,
    allowSelectAll: Boolean,
    hideCheckboxesOnItems: Boolean,
    itemValueKey: {
      type: String,
      default: "Id"
    },
    dialogTrigger: Number,
    dialogItem: Object,
    dialogMethodConfig: Object,
    lockedFilters: Object,
    optionalFilters: Object,
    exportFunction: Function,
    previewable: Boolean,
    selectText: String,
    alternateSelectActions: Array,
    createNewFunction: Function,
    quickClickFunction: Function,
    onMiddleClick: Function,
    groupBy: [Function, String],
    groupSort: Function,
    groupItemSort: Function,
    scrollcheckTrigger: Number,
    itemDeleteFunc: Function
  },
  components: {
    ListPane,
    MultiselectActionBar,
    SelectableListItemWrapper,
  },
  mixins: [FilterQueryMixin],

  data() {
    return {
      selected: {},
      excluded: {},
      selectLoading: false,
      previewIndex: null,

      selectionFilter: {
        SelectAll: false,
        prependItemIdMap: {},   //FE only, for more efficient lookups
        PrependItemIdList: [],
        excludeItemIdMap: {},    //FE only, for more efficient lookups
        ExcludeItemIdList: []
      },
    };
  },

  methods: {
    setPreviewIndex(index) {
      this.previewIndex = index;
    },

    async handleItemDelete(item, action, cleanupAction) {
      await action(item);
      cleanupAction(item);
    },

    toggleSelectAll() {
      var freshObj = {}; // toggling select all resets all selection filters
      freshObj.SelectAll = !this.selectionFilter.SelectAll;
      this.setSelectionFilter(freshObj);
    },

    setSelectionFilter(newVal) {
      var count = this.getCheckedItemCount(newVal);
      var eCount = this.getUncheckedItemCount(newVal);
      newVal.checkedCount = count;
      newVal.uncheckedCount = eCount;
      Vue.set(this, 'selectionFilter', newVal); //force reactivity
      //console.log('setSelectionFilter', newVal);

    },

    handlePreview(item, index) {
      this.setPreviewIndex(index);
      item ? this.$emit("openPreview", item) : this.$emit("closePreview");
    },

    handleItemClick(item) {
      //if multiple, no selection has been made, and quickClickFunction is defined, call the function
      if (this.quickClickFunction !== undefined && !(this.selectionFilter.checkedCount || this.selectionFilter.SelectAll) && this.multiple) {
        this.quickClickFunction(item);
      }
      //else do regular selection logic on click
      else {
        this.toggleitem(item);
        //if single mode and item is now selected, emit selection right away
        if (!this.multiple) {
          this.select();
        }
      }
    },

    handleMiddleClick(item) {
      if (this.onMiddleClick !== undefined) {
        this.onMiddleClick(item);
      }
    },

    clearAllSelection() {
      var freshObj = {}; // toggling select all resets all selection filters
      freshObj.SelectAll = false;
      this.setSelectionFilter(freshObj);
    },

    refreshList() {
      this.$refs.listpane.fetch();
    },

    toggleitem(item) {
      //console.log('toggleitem', item);
      var copy = Object.assign({}, this.selectionFilter);
      const id = item[this.itemValueKey];
      const checkedState = this.isChecked(item);
      if (copy.SelectAll) {
        copy.excludeItemIdMap = { ...copy.excludeItemIdMap, [id]: checkedState };
        copy.ExcludeItemIdList = Object.keys(copy.excludeItemIdMap).filter(k => copy.excludeItemIdMap[k]);
      }
      else {
        copy.prependItemIdMap = { ...copy.prependItemIdMap, [id]: !checkedState };
        copy.PrependItemIdList = Object.keys(copy.prependItemIdMap).filter(k => copy.prependItemIdMap[k]);
      }
      this.setSelectionFilter(copy);
    },

    async select() {
      this.$emit("select", this.selectionFilter);
    },

    isChecked(item) {
      const id = item[this.itemValueKey];
      if (this.selectionFilter.SelectAll) {
        return !this.selectionFilter.excludedItemIdMap?.[id];
      }
      else {
        return this.selectionFilter.prependItemIdMap?.[id];
      }
    },

    getCheckedItemCount(selectionFilter) {
      var keys = Object.keys(selectionFilter);
      keys = keys.filter(k => k.endsWith("IdList") && /^[A-Z]/.test(k));
      keys = keys.filter(k => selectionFilter[k] && selectionFilter[k].length);
      //console.log("getCheckedItemCount", keys.length, keys, selectionFilter);
      return keys.length || selectionFilter.SelectAll ? 1 : 0;
    },

    getUncheckedItemCount(selectionFilter) {
      var keys = Object.keys(selectionFilter);
      keys = keys.filter(k => k.startsWith("Excluded") && /^[A-Z]/.test(k));
      keys = keys.filter(k => selectionFilter[k] && selectionFilter[k].length);
      //console.log("getUncheckedItemCount", keys.length, keys, selectionFilter);
      return keys.length;
    },
  },

  computed: {
    mixedFilters() {
      //console.log('mixed', { ...this.optionalFilters, ...this.lockedFilters });
      return { ...this.optionalFilters, ...this.lockedFilters };
    },
  },

  watch: {},
};
</script>


<style scoped></style>